module.exports = __webpack_public_path__ + "img/tax-forms.87000cff.svg";